import { useQuery } from '@tanstack/react-query';

import { getCollections } from './clients';

function useArticleCollections() {
  const queryData = useQuery(['collections'], () => getCollections(), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  return queryData;
}

export default useArticleCollections;
